export const PRODUCT_OPTION_KEY = 'productOption';
export const SCOOTERS_PRODUCT_OPTION_DATA_TEST_ID = 'scooters-productOptions_data-test-id';
export const BOATS_PRODUCT_OPTION_DATA_TEST_ID = 'boats-productOptions_data-test-id';
